import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralProvider } from '@hero/web-hooks';

/**
 * Dashboard mount of the shared `ReferralProvider`: captures `?r=CODE`
 * on any dashboard URL (a partner link pointing straight at
 * `app.tryhero.io/?r=…`), stores the referral cookies, registers the
 * PostHog referral super-properties and posts one `view` hit. The
 * signup wizard reads the same cookies via
 * `getReferralAttributionFields()`; CTAs use `useReferral()` /
 * `<ReferralCta>`. Mounted once in `main.tsx` inside `ApiProvider`.
 */
export function ReferralCapture({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  return (
    <ReferralProvider business="hero" language={i18n.language}>
      {children}
    </ReferralProvider>
  );
}
